import React from "react";
import { Button, Stack } from "@mui/material";
import request from "src/utils/request";
import { ToastContext } from "src/components/providers/toast-provider";
import { useTeam } from "./team-provider";
import useTeamAction from "../hooks/use-team-action";

const CancelInvitationButton = ({ onSuccess, invite }) => {
    const { setMessage, setSeverity, setIsToastTriggered } = React.useContext(ToastContext);
    const leaveAction = useTeamAction(
        async () => {
            const params = new URLSearchParams({
                targetUnit: invite.targetUnit,
            });
            const invitesToCancel = [
                {
                    targetUnit: invite.targetUnit,
                    email: invite.email,
                },
            ];
            await request(`api/invites?${params.toString()}`, {
                method: "DELETE",
                body: JSON.stringify(invitesToCancel),
            });
            setMessage(`You have successfully cancelled the invitation`);
            setSeverity("success");
            setIsToastTriggered(true);
            onSuccess();
        },
        () => {
            setMessage(`You can not perform this action on demo mode`);
            setSeverity("warning");
            setIsToastTriggered(true);
        }
    );

    const handleClick = async () => {
        setIsToastTriggered(false);
        try {
            leaveAction();
        } catch (e) {
            setMessage(`There was an error cancelling the invitation`);
            setSeverity("error");
            setIsToastTriggered(true);
        }
    };
    return (
        <Button color="warning" style={{ textTransform: "none" }} onClick={handleClick}>
            Cancel invitation
        </Button>
    );
};

const TeamInviteCardActions = ({ invite, onModalClose }) => {
    const teamApi = useTeam();

    if (!teamApi || !teamApi.data) return null;

    const onSuccess = () => {
        teamApi.refetch();
        onModalClose();
    };

    const buttonProps = {
        onSuccess,
        team: teamApi.data,
        invite,
    };

    return (
        <Stack direction="row" justifyContent="space-between" spacing={2}>
            <div />
            <CancelInvitationButton {...buttonProps} />
        </Stack>
    );
};

export default TeamInviteCardActions;
